import { gql } from "lib/apolloClient";
import {
  criteriaValueFragment,
  studentFragment,
  staffFragment,
  attachmentFragment,
} from "modules/CommonFragments";

export const commonFragments = {
  ibPYPElementRatings: gql`
    fragment ibPYPElementRatings on IBPYPElementRating {
      id
      ibPYPElementId
      ibPYPElementType
      academicCriteriaValue {
        ...criteriaValueItem
      }
    }
    ${criteriaValueFragment.criteriaValue}
  `,
  plannerField: gql`
    fragment plannerFieldItem on PlannerField {
      id
      uid
      value
      resolvedMinimalTree {
        id
        type
        ... on ResolvedFieldPlannerElementSet {
          id
          type
          ... on ResolvedFieldPlannerElementSet {
            id
            type
            nodes {
              id
              label
              type
            }
          }
        }
      }
    }
  `,
};

export const studentProjectFragment = {
  projectFragment: gql`
    fragment projectInfo on Project {
      id
      supervisors {
        ...staffItem
      }
      fields {
        ...plannerFieldItem
      }
      reportStatus
      status
      studentCollaborators {
        student {
          ...studentItem
        }
      }
      completedDeadlines {
        completedAt
        deadline {
          id
          deadlineDate
        }
      }
      finalProjectReports {
        ...attachmentItem
      }
      ibPYPElementRatings {
        id
        value
        ibPYPElementId
        ibPYPElementType
        isComputedRating
        academicCriteriaSet {
          id
          criteriaType
        }
        academicCriteriaValue {
          id
          label
          abbreviation
        }
      }
    }
    ${staffFragment.basicStaffDetails}
    ${commonFragments.plannerField}
    ${studentFragment.basicStudentDetails}
    ${attachmentFragment.attachment}
  `,
};

export const studentInfofragment = {
  additionalInfo: gql`
    fragment studentAdditionalInfoItem on Student {
      id
      isBlocked
      enrollmentDate
      withdrawalDate
      studentAdditionalInfos {
        id
        fieldUid
        value
      }
    }
  `,
  studentCourses: gql`
    fragment studentCoursesItem on Student {
      id
      firstName
      lastName
      yearGroup {
        id
        name
        grade {
          id
        }
        curriculumProgram {
          id
          type
          nodeInterfaceType
          label
          acronym
        }
      }
      courseMap(filters: $courseFilters) {
        id
        course {
          id
          title
          isDemo
          genericTags {
            id
            label
            type
            abbreviation
          }
          profileImageData {
            url
            icon
            color
            acronym
          }
          subjects {
            id
            name
          }
          subjectLevelMap {
            subject {
              id
              name
            }
            associatedLevels {
              id
              label
              abbreviation
            }
          }
          curriculumProgram {
            id
            type
            academicSetupType
          }
          learningCourse {
            id
            title
            academicCourse {
              id
              label
              code
            }
          }
          collaborators: allCollaborators {
            edges {
              node {
                id
              }
            }
          }
        }
        subjectWiseLevel {
          level {
            id
            label
            abbreviation
          }
          subject {
            id
            name
          }
        }
        tags {
          id
          type
          label
        }
      }
    }
  `,
};

export const continuumBasicDetailsFragments = {
  continuumBasicDetails: gql`
    fragment continuumBasicDetails on Continuum {
      id
      label
      updatedAt
      nodes {
        id
        label
        subText
        type
        gradingType
        depth
        displaySequence
        parentId
        children
        metaData
      }
      createdBy {
        id
        firstName
        lastName
      }
      associatedEntities {
        id
        ... on Grade {
          id
          name
        }
        ... on Subject {
          id
          name
        }
      }
    }
  `,
};

export const studentOffenceFragments = {
  studentOffence: gql`
    fragment studentOffence on StudentOffense {
      id
      offenseDegree
      frequency
      description
      ibPypElementRemarks {
        id
        ibPYPElementId
        ibPYPElementType
        student {
          id
        }
        parent {
          id
        }
        message
        academicTerm {
          id
          label
        }
      }
      ibPYPElementRatings {
        id
        ibPYPElementId
        ibPYPElementType
        student {
          id
        }
        parent {
          id
        }
        value
        academicTerm {
          id
          label
        }
      }
      academicCriteriaSet {
        id
      }
    }
  `,
};

export const gainContinuumFragment = {
  continuumBasicDetails: gql`
    fragment continuumBasicDetailsItem on ContinuumRating {
      ratings {
        id
        academicCriteriaSet {
          id
        }
        ibPYPElementId
        ibPYPElementType
        parent {
          id
        }
        value
        academicTerm {
          id
          label
        }
      }
    }
  `,
  continuumRemarkBasicDetails: gql`
    fragment continuumRemarkBasicDetailsItem on ContinuumRemark {
      remarks {
        id
        academicCriteriaSet {
          id
        }
        ibPYPElementId
        ibPYPElementType
        parent {
          id
        }
        message
        academicTerm {
          id
          label
        }
      }
    }
  `,
};

export const IBPYPElementRatingFragments = {
  IBPYPElementRatingBasicDetails: gql`
    fragment IBPYPElementRatingBasicDetailsItem on IBPYPElementRating {
      id
      student {
        id
        firstName
      }
      ibPYPElementId
      ibPYPElementType
      parent {
        id
      }
      parentType
      value
      academicTerm {
        id
        label
      }
      academicCriteriaSet {
        id
      }
    }
  `,
};

export const studentAlertFragment = gql`
  fragment studentAlertFields on StudentAlert {
    id
    title
    description
    alertType {
      id
      name
      icon
      isEnabled
    }
    attachments {
      ...attachmentItem
    }
    expiresAt
    createdAt
    createdBy {
      ...staffItem
    }
    isArchived
    archivedAt
    archivedBy {
      ...staffItem
    }
  }
  ${attachmentFragment.attachment}
  ${staffFragment.basicStaffDetails}
`;
